import React, { Component } from "react";
import { Link } from "react-router-dom";

import Header from "../component/Header";
import BottomNav from "../component/BottomNav";
import BookList from "../component/BookList";

import cookie from 'react-cookie';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-125086411-4');

class CategoryView extends Component {

	constructor(props) {
		super(props);

		//this.state = { forecasts: [], loading: true };
		//alert(props);

		this.state = { headerTitle: "더책" };

		this.state = { ...this.state, totalcount: 0, booklist: [], loading: true };

		fetch('api/AB/BookList?pgidx=0&pgsize=50&orderby=1&orderway=1')
			.then(response => response.json())
			.then(data => {
				//this.setState({ forecasts: data, loading: false });
				//alert(JSON.stringify(data));
				//alert(data.totalcount);
				//this.state.totalcount = data.totalcount;
				//this.state.loading = true;
				//alert(this.state.totalcount);

				this.setState({ totalcount: data.totalcount, booklist: data.lstresult, loading: false });
			});
	}

	dorender() {
		return (
			<p className="section-description">{this.state.totalcount} 건의 책이 있습니다.</p>
		);
	}

    logPageView() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.pageview(window.location + "&orgid=" + cookie.load("orgid"));
    }

    render() {

		let contents = this.state.loading === true
			? <p className="section-description">Loading...</p>
            : this.dorender(); this.logPageView();

		return (
			<React.Fragment>
				<Header headerTitle={this.state.headerTitle} />

				<div className="section">
					<div className="section-header">
						<h2 className="section-title">
							<Link path="/">전체</Link>
						</h2>
						{contents}
					</div>
					<div className="section-body">
						<BookList bl={this.state.booklist} />
					</div>
				</div>

				<BottomNav />
			</React.Fragment>
		);
	}
}

export default CategoryView;
